import styled from 'styled-components';

export const BreadcrumbsContainer = styled.div`
    width: 90%;
    ${props => props.theme.devices.mobile} {
        margin-top: 30px;
    }
`;
